if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.requestId = 0;
        this.abortController = null;
        this.style.display = 'contents';

        if (this.hasItems()) {
          this.showSection();
        }

        this.loadRecommendations();
      }

      disconnectedCallback() {
        this.cancelRequest();
      }

      get sectionRoot() {
        return this.closest('.product-recommendations') || this;
      }

      hasItems() {
        return !!this.querySelector('slideshow-container-item');
      }

      showSection() {
        const root = this.sectionRoot;
        root.hidden = false;
        root.style.display = 'block';
      }

      hideSection() {
        const root = this.sectionRoot;
        root.hidden = true;
        root.style.display = 'none';
      }

      cancelRequest() {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      }

      loadRecommendations() {
        const url = this.dataset.url;
        if (!url) return;

        this.cancelRequest();
        this.abortController = new AbortController();
        const requestId = (this.requestId += 1);

        fetch(url, {
          signal: this.abortController.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then((response) => {
            if (!response.ok) throw new Error('Product recommendations request failed');
            return response.text();
          })
          .then((html) => {
            if (requestId !== this.requestId) return;
            this.renderRecommendations(html);
          })
          .catch((error) => {
            if (error && error.name === 'AbortError') return;
            if (!this.hasItems()) this.hideSection();
          });
      }

      renderRecommendations(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newWidget = doc.querySelector('.widget-product');
        const currentWidget = this.querySelector('.widget-product');

        if (!newWidget || !newWidget.querySelector('slideshow-container-item')) {
          if (!this.hasItems()) this.hideSection();
          return;
        }

        if (currentWidget) {
          currentWidget.replaceWith(newWidget);
        } else {
          this.appendChild(newWidget);
        }

        this.showSection();

        if (typeof window.initProductPreviewSizes === 'function') {
          window.initProductPreviewSizes();
        }
      }
    }
  );
}
